import PropTypes from 'prop-types';

const TextError = ({ children }) => (
  <div className="ml-2 !text-red-500">{children}</div>
);

TextError.propTypes = {
  children: PropTypes.node,
};

export default TextError;
